_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[19],{

/***/ "+ZtJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
var styles = ["@media (max-width:30em){.hero__brand--priceblocs.jsx-1538710231{height:3rem;}}", "@media (min-width:30em) and (max-width:60em){.hero__brand--priceblocs.jsx-1538710231{height:3rem;}}", "@media (min-width:60em){.hero__brand--priceblocs.jsx-1538710231{height:4rem;}}", ".hero__logo.jsx-1538710231{background-image:url(\"/tutorials/assets/hero__logo.png\");}", ".bg__hero.jsx-1538710231::before{content:\"\";position:absolute;top:0;left:0;right:0;width:100%;pointer-events:none;height:100%;background-color:transparent;background-repeat:no-repeat;z-index:-1;}", "@media (max-width:30em){.bg__hero.jsx-1538710231::before{background-position:top;background-size:contain;}}", "@media (min-width:30em) and (max-width:60em){.bg__hero.jsx-1538710231::before{background-position:right;background-size:contain;background-image:url(\"/tutorials/assets/bg__hero--desktop.svg\");}}", "@media (min-width:60em){.bg__hero.jsx-1538710231::before{background-position:right;background-size:contain;background-image:url(\"/tutorials/assets/bg__hero--desktop.svg\");}}"];
styles.__hash = "1538710231";

/***/ }),

/***/ "2ePE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__N_SSG", function() { return __N_SSG; });
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("MX0m");
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_Tutorials_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("NCNY");
/* harmony import */ var _components_Padder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("gH8l");
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("QMec");
/* harmony import */ var _components_Landing_HeroSection_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+ZtJ");
/* harmony import */ var _components_Static_PostGrid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("hTwA");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;





 // Used to be tutorial email

var EmailChannel = function EmailChannel(_ref) {
  var navConfig = _ref.navConfig,
      posts = _ref.posts;
  var filteredPosts = posts.sort(function (a, b) {
    return Number(new Date(b.publishedAt)) - Number(new Date(a.publishedAt));
  });
  return __jsx(_components_Tutorials_Container__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"], {
    navConfig: navConfig
  }, __jsx("div", {
    className: "jsx-".concat(_constants_styles__WEBPACK_IMPORTED_MODULE_4__[/* cellGrow */ "a"].__hash, " jsx-").concat(_components_Landing_HeroSection_styles__WEBPACK_IMPORTED_MODULE_5__[/* styles */ "a"].__hash) + " " + "w-100 overflow-y-scroll-l"
  }, __jsx("div", {
    className: "jsx-".concat(_constants_styles__WEBPACK_IMPORTED_MODULE_4__[/* cellGrow */ "a"].__hash, " jsx-").concat(_components_Landing_HeroSection_styles__WEBPACK_IMPORTED_MODULE_5__[/* styles */ "a"].__hash) + " " + "w-100 pv4 pv5-l mw8 w-100 center"
  }, __jsx("div", {
    className: "jsx-".concat(_constants_styles__WEBPACK_IMPORTED_MODULE_4__[/* cellGrow */ "a"].__hash, " jsx-").concat(_components_Landing_HeroSection_styles__WEBPACK_IMPORTED_MODULE_5__[/* styles */ "a"].__hash) + " " + "dib hero__brand--priceblocs w-100 z-1"
  }, __jsx("div", {
    className: "jsx-".concat(_constants_styles__WEBPACK_IMPORTED_MODULE_4__[/* cellGrow */ "a"].__hash, " jsx-").concat(_components_Landing_HeroSection_styles__WEBPACK_IMPORTED_MODULE_5__[/* styles */ "a"].__hash) + " " + "hero__logo contain bg-left h-100 w-100"
  })), __jsx("div", {
    className: "jsx-".concat(_constants_styles__WEBPACK_IMPORTED_MODULE_4__[/* cellGrow */ "a"].__hash, " jsx-").concat(_components_Landing_HeroSection_styles__WEBPACK_IMPORTED_MODULE_5__[/* styles */ "a"].__hash) + " " + "pt3 pt4-l pb4"
  }, __jsx("h1", {
    className: "jsx-".concat(_constants_styles__WEBPACK_IMPORTED_MODULE_4__[/* cellGrow */ "a"].__hash, " jsx-").concat(_components_Landing_HeroSection_styles__WEBPACK_IMPORTED_MODULE_5__[/* styles */ "a"].__hash) + " " + "fw6 f3 f2-l pa0 ma0 pb3 pt2"
  }, "Email"), __jsx("h3", {
    className: "jsx-".concat(_constants_styles__WEBPACK_IMPORTED_MODULE_4__[/* cellGrow */ "a"].__hash, " jsx-").concat(_components_Landing_HeroSection_styles__WEBPACK_IMPORTED_MODULE_5__[/* styles */ "a"].__hash) + " " + "f5 f4-l pt0 fw5 ma0 pa0 lh-copy"
  }, "How to use payment links with your favorite email providers.")), __jsx(_components_Static_PostGrid__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"], {
    posts: filteredPosts
  })), __jsx(_components_Padder__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], {
    theme: "visible"
  }), __jsx(styled_jsx_style__WEBPACK_IMPORTED_MODULE_0___default.a, {
    id: _constants_styles__WEBPACK_IMPORTED_MODULE_4__[/* cellGrow */ "a"].__hash
  }, _constants_styles__WEBPACK_IMPORTED_MODULE_4__[/* cellGrow */ "a"]), __jsx(styled_jsx_style__WEBPACK_IMPORTED_MODULE_0___default.a, {
    id: _components_Landing_HeroSection_styles__WEBPACK_IMPORTED_MODULE_5__[/* styles */ "a"].__hash
  }, _components_Landing_HeroSection_styles__WEBPACK_IMPORTED_MODULE_5__[/* styles */ "a"])));
};

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (EmailChannel);

/***/ }),

/***/ "FPmr":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/email",
      function () {
        return __webpack_require__("2ePE");
      }
    ]);
  

/***/ }),

/***/ "QMec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cellGrow; });
/* unused harmony export paymentStyles */
/* harmony import */ var _utils_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("oCA+");

var cellGrow = [".cell-grow{-moz-osx-font-smoothing:grayscale;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0);-webkit-transition:-webkit-transform 0.25s ease-out;-webkit-transition:transform 0.25s ease-out;transition:transform 0.25s ease-out;}", ".cell-grow:hover,.cell-grow:focus{-webkit-transform:scale(1.0075);-ms-transform:scale(1.0075);transform:scale(1.0075);}", ".cell-grow:active{-webkit-transform:scale(0.99);-ms-transform:scale(0.99);transform:scale(0.99);}"];
cellGrow.__hash = "1514576463";
var paymentStyles = [".result-message.jsx-1470479211{line-height:22px;font-size:16px;}", ".result-message.jsx-1470479211 a.jsx-1470479211{color:rgb(89,111,214);font-weight:600;-webkit-text-decoration:none;text-decoration:none;}", ".hidden.jsx-1470479211{display:none;}", "#card-error.jsx-1470479211{color:rgb(105,115,134);font-size:16px;line-height:20px;margin-top:12px;text-align:center;}", "#card-element.jsx-1470479211{border-radius:4px 4px 0 0;padding:12px;border:1px solid rgba(50,50,93,0.1);max-height:44px;width:100%;background:white;box-sizing:border-box;}", "#payment-request-button.jsx-1470479211{margin-bottom:32px;}", "button.jsx-1470479211{background:".concat(_utils_styles__WEBPACK_IMPORTED_MODULE_0__[/* COLORS */ "a"].blue, ";color:").concat(_utils_styles__WEBPACK_IMPORTED_MODULE_0__[/* COLORS */ "a"].white, ";border-radius:0 0 4px 4px;border:0;padding:12px 16px;font-size:16px;font-weight:600;cursor:pointer;display:block;-webkit-transition:all 0.2s ease;transition:all 0.2s ease;box-shadow:0px 4px 5.5px 0px rgba(0,0,0,0.07);width:100%;}"), "button.jsx-1470479211:hover{-webkit-filter:contrast(115%);filter:contrast(115%);}", "button.jsx-1470479211:disabled{opacity:0.5;cursor:default;}", ".spinner.jsx-1470479211,.spinner.jsx-1470479211:before,.spinner.jsx-1470479211:after{border-radius:50%;}", ".spinner.jsx-1470479211{color:".concat(_utils_styles__WEBPACK_IMPORTED_MODULE_0__[/* COLORS */ "a"].white, ";font-size:22px;text-indent:-99999px;margin:0px auto;position:relative;width:20px;height:20px;box-shadow:inset 0 0 0 2px;-webkit-transform:translateZ(0);-ms-transform:translateZ(0);-webkit-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0);}"), ".spinner.jsx-1470479211:before,.spinner.jsx-1470479211:after{position:absolute;content:\"\";}", ".spinner.jsx-1470479211:before{width:10.4px;height:20.4px;background:".concat(_utils_styles__WEBPACK_IMPORTED_MODULE_0__[/* COLORS */ "a"].blue, ";border-radius:20.4px 0 0 20.4px;top:-0.2px;left:-0.2px;-webkit-transform-origin:10.4px 10.2px;-webkit-transform-origin:10.4px 10.2px;-ms-transform-origin:10.4px 10.2px;transform-origin:10.4px 10.2px;-webkit-animation:loading 2s infinite ease 1.5s;-webkit-animation:loading-jsx-1470479211 2s infinite ease 1.5s;animation:loading-jsx-1470479211 2s infinite ease 1.5s;}"), ".spinner.jsx-1470479211:after{width:10.4px;height:10.2px;background:".concat(_utils_styles__WEBPACK_IMPORTED_MODULE_0__[/* COLORS */ "a"].blue, ";border-radius:0 10.2px 10.2px 0;top:-0.1px;left:10.2px;-webkit-transform-origin:0px 10.2px;-webkit-transform-origin:0px 10.2px;-ms-transform-origin:0px 10.2px;transform-origin:0px 10.2px;-webkit-animation:loading 2s infinite ease;-webkit-animation:loading-jsx-1470479211 2s infinite ease;animation:loading-jsx-1470479211 2s infinite ease;}"), "@-webkit-keyframes loading-jsx-1470479211{0%{-webkit-transform:rotate(0deg);-webkit-transform:rotate(0deg);-ms-transform:rotate(0deg);transform:rotate(0deg);}100%{-webkit-transform:rotate(360deg);-webkit-transform:rotate(360deg);-ms-transform:rotate(360deg);transform:rotate(360deg);}}", "@keyframes loading-jsx-1470479211{0%{-webkit-transform:rotate(0deg);-webkit-transform:rotate(0deg);-ms-transform:rotate(0deg);transform:rotate(0deg);}100%{-webkit-transform:rotate(360deg);-webkit-transform:rotate(360deg);-ms-transform:rotate(360deg);transform:rotate(360deg);}}", "@media only screen and (max-width:600px){form.jsx-1470479211{width:80vw;}}"];
paymentStyles.__hash = "1470479211";

/***/ }),

/***/ "hTwA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__("MX0m");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/constants/ui.js
var ui = __webpack_require__("IWZK");

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__("YFqc");
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);

// CONCATENATED MODULE: ./src/components/Tutorials/PostSummary/index.jsx

var __jsx = react_default.a.createElement;


var PostSummary_PostSummary = function PostSummary(_ref) {
  var title = _ref.title,
      summary = _ref.summary,
      slug = _ref.slug,
      path = _ref.path;
  var linkProps = {
    as: path ? path.as : "/",
    href: path ? path.href : "/"
  };
  return __jsx(link_default.a, linkProps, __jsx("a", {
    className: "w-100 link mb3"
  }, __jsx("div", {
    className: "mb2 w-100"
  }, __jsx("div", {
    className: "flex flex-column flex-row-ns justify-between"
  }, __jsx("h4", {
    className: "f4 fw6 color-primary link mv0 pt1 lh-title"
  }, title)), __jsx("p", {
    className: "color-text--primary lh-copy"
  }, summary))));
};

/* harmony default export */ var Tutorials_PostSummary = (PostSummary_PostSummary);
// EXTERNAL MODULE: ./src/components/Image/index.jsx + 2 modules
var Image = __webpack_require__("W56c");

// EXTERNAL MODULE: ./src/constants/styles.js
var styles = __webpack_require__("QMec");

// EXTERNAL MODULE: ./src/utils/env.js
var env = __webpack_require__("5JAB");

// CONCATENATED MODULE: ./src/components/Static/PostGrid/index.jsx


var PostGrid_jsx = react_default.a.createElement;







var PostGrid_PostGrid = function PostGrid(_ref) {
  var posts = _ref.posts;
  return PostGrid_jsx("div", {
    className: "jsx-3270448994" + " " + "post__grid"
  }, posts.map(function (frontMatter, fix) {
    var dimensions = frontMatter.service && ui["l" /* SERVICE_ICON_DIMENSIONS_MAP */][frontMatter.service];
    return PostGrid_jsx("div", {
      key: fix,
      className: "jsx-3270448994" + " " + "ba hairline-1 br2 pointer cell-grow bg-white--hover ba--primary--hover relative"
    }, PostGrid_jsx("div", {
      className: "jsx-3270448994" + " " + "pa2"
    }, PostGrid_jsx(Tutorials_PostSummary, Object(esm_extends["a" /* default */])({
      key: frontMatter.title
    }, frontMatter))), dimensions ? PostGrid_jsx(react["Fragment"], null, PostGrid_jsx("div", {
      style: {
        height: 42
      },
      className: "jsx-3270448994" + " " + "w-100"
    }), PostGrid_jsx("div", {
      className: "jsx-3270448994" + " " + "relative ph2 pv1 bt hairline-1 absolute left-0 bottom-0 right-0"
    }, PostGrid_jsx(Image["a" /* default */], {
      src: "".concat(Object(env["a" /* getConfig */])("BASE_PATH"), "/assets/service--").concat(frontMatter.service, ".png"),
      width: dimensions.width / 4,
      height: dimensions.height / 4,
      priority: true
    }))) : null);
  }), PostGrid_jsx(style_default.a, {
    id: styles["a" /* cellGrow */].__hash
  }, styles["a" /* cellGrow */]), PostGrid_jsx(style_default.a, {
    id: "3270448994"
  }, ["@media (max-width:30em){.post__grid.jsx-3270448994{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}}", "@media (min-width:30em){.post__grid.jsx-3270448994{display:grid;grid-template-columns:repeat(3,1fr);grid-template-rows:repeat(3,1fr);gap:8px 8px;}}"]));
};

/* harmony default export */ var Static_PostGrid = __webpack_exports__["a"] = (PostGrid_PostGrid);

/***/ })

},[["FPmr",1,2,3,4,5,8,9,7,0,6,10]]]);